export const THEME_STORAGE_KEY = 'ptheme';
export const THEME_GLOBAL_ATTRIBUTE = 'data-ptheme';
export const THEME_LIGHT_ID = 'light';
export const THEME_DARK_ID = 'dark';
